import { z } from "zod";

export const WorkbenchTabGroupId = z
  .string()
  // eslint-disable-next-line tree-shaking/no-side-effects-in-initialization -- building a schema is pure; the rule cannot see through a chained builder
  .brand("WorkbenchTabGroupId");
export type WorkbenchTabGroupId = z.infer<typeof WorkbenchTabGroupId>;

export type WorkbenchTabGroup<T extends WorkbenchTab = WorkbenchTab> = {
  id: WorkbenchTabGroupId;
  /** The tabs in this group. */
  tabs: T[];
  /** The currently focused tab within this group. */
  currentTabId: WorkbenchTabId;
};

export const WorkbenchTabId = z
  .string()
  // eslint-disable-next-line tree-shaking/no-side-effects-in-initialization -- building a schema is pure; the rule cannot see through a chained builder
  .brand("WorkbenchTabId");
export type WorkbenchTabId = z.infer<typeof WorkbenchTabId>;

export interface WorkbenchTab {
  id: WorkbenchTabId;
  /** If true, this tab will be closed if any
   * other tab within this group becomes focused. */
  isPreview?: boolean;
}
